import React from "react";
import { orderBy } from "lodash";
import { findAnswerLevelToQuestion } from "../../../data/utils";
import "../../../styles//SimpleQuizz/ZoneReponses/AnswerListButtons.css";
import { stringToHTML } from "../../../data/utils";
export const AnswerListButtons = ({
  question,
  questionId,
  userAnswers,
  setUserAnswers,
}) => {
  const handleClickAnswer = ({ questionId, level }) => {
    const userAnswersWithoutCurrentQuestionAnswer = userAnswers.filter(
      (answer) => answer.questionId !== questionId
    );
    setUserAnswers(
      // needed to keep the flower consistent
      orderBy(
        [...userAnswersWithoutCurrentQuestionAnswer, { questionId, level }],
        (answer) => answer.questionId
      )
    );
  };
  const ReponsesPossibles = orderBy(
    question.options,
    (reponse) => reponse.level,
    "asc"
  );
  // On a ordonné l'affichage des réponses selon le niveau croissant.
  return ReponsesPossibles.map((option) => (
    <button
      className={`button_answer button_${
        findAnswerLevelToQuestion(questionId, userAnswers) === option.level
          ? `${question.theme.split(" ")[1]}`
          : null
      }`}
      key={option.answer}
      onClick={() => handleClickAnswer({ questionId, level: option.level })}
    >
      {stringToHTML(option.answer)}
    </button>
  ));
};
